import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface ProfesionalConEstablecimientosDialogProps {
  open: boolean;
  uidProfesional: string;
  nombre: string;
  onClose: () => void;
}

export function ProfesionalConEstablecimientosDialog({
  open,
  uidProfesional,
  nombre,
  onClose,
}: ProfesionalConEstablecimientosDialogProps): JSX.Element {
  const navigate = useNavigate();

  function handleVerEstablecimientos(): void {
    onClose();
    navigate(`/establecimientos?profesional=${uidProfesional}`);
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>No se puede eliminar</DialogTitle>
      <DialogContent>
        <DialogContentText>
          El profesional <strong>{nombre}</strong> tiene establecimientos asignados.
          Reasigná esos establecimientos a otro profesional antes de eliminarlo.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
        <Button onClick={handleVerEstablecimientos} variant="contained">
          Ver establecimientos
        </Button>
      </DialogActions>
    </Dialog>
  );
}
